import colors from 'utils/colors';

const customStyles = {
  option: (base, state) => {
    return state.isSelected
      ? { ...base, backgroundColor: colors.primary }
      : { ...base, color: '#31A1DA' };
  },
  control: base => ({
    // none of react-selects styles are passed to <View />
    ...base,
    background: '#E8F0F7',
    minWidth: 200,
  }),
  dropdownIndicator: base => ({
    ...base,
  }),
};

export default customStyles;
